import React from "react";
import "./styles.scss";
import { FeatureCard } from "atoms";

const generateCards = cards =>
  cards.map(item => (
    <FeatureCard
      icon={item.icon}
      title={item.title}
      description={item.description}
    />
  ));

export default props => (
  <div className="feature-grid">{generateCards(props.cards || [])}</div>
);
